import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/dashboard/index.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('../views/home/index.vue')
      },
      {
        path: 'managers',
        name: 'Managers',
        component: () => import('../views/managers/index.vue'),
        meta: { title: '管理员管理', requiresAuth: true }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('../views/users/index.vue'),
        meta: { title: '用户管理', requiresAuth: true }
      },
      {
        path: 'carousel',
        name: 'Carousel',
        component: () => import('../views/carousel/index.vue'),
        meta: { title: '轮播图管理', requiresAuth: true }
      },
      {
        path: 'message',
        name: 'News',
        component: () => import('../views/news/index.vue'),
        meta: { title: '脱单资讯', requiresAuth: true }
      },
      {
        path: 'protocol',
        name: 'Protocol',
        component: () => import('../views/protocol/index.vue'),
        meta: { title: '协议说明管理', requiresAuth: true }
      },
      {
        path: 'faq',
        name: 'Faq',
        component: () => import('../views/faq/index.vue'),
        meta: { title: '常见问题管理', requiresAuth: true }
      },
      {
        path: 'member-settings',
        name: 'MemberSettings',
        component: () => import('../views/settings/member-settings/index.vue'),
        meta: { title: '会员设置', requiresAuth: true }
      },
      {
        path: 'platform-intro',
        name: 'PlatformIntro',
        component: () => import('../views/settings/platform-intro/index.vue'),
        meta: { title: '平台介绍', requiresAuth: true }
      },
      {
        path: 'matchmaker-intro',
        name: 'MatchmakerIntro',
        component: () => import('../views/settings/matchmaker-intro/index.vue'),
        meta: { title: '红娘服务团介绍', requiresAuth: true }
      },
      {
        path: 'fraud-prevention',
        name: 'FraudPrevention',
        component: () => import('../views/settings/fraud-prevention/index.vue'),
        meta: { title: '防骗指南', requiresAuth: true }
      },
      {
        path: 'member-category',
        name: 'MemberCategory',
        component: () => import('../views/members/category/index.vue'),
        meta: { title: '会员分类', requiresAuth: true }
      },
      {
        path: 'member-management',
        name: 'MemberManagement',
        component: () => import('../views/members/management/index.vue'),
        meta: { title: '会员管理', requiresAuth: true }
      },
      {
        path: 'matchmaking',
        name: 'Matchmaking',
        component: () => import('../views/matchmaking/index.vue'),
        meta: { title: '相亲会管理', requiresAuth: true }
      },
        {
          path: 'reviews',
          name: 'Reviews',
          component: () => import('../views/reviews/index.vue'),
          meta: { title: '真实好评', requiresAuth: true }
        },
        {
          path: 'housekeeper',
          name: 'Housekeeper',
          component: () => import('../views/housekeeper/index.vue'),
          meta: { title: '管家管理', requiresAuth: true }
        },
        {
          path: 'matchmaker',
          name: 'Matchmaker',
          component: () => import('../views/matchmaker/index.vue'),
          meta: { title: '红娘管理', requiresAuth: true }
        },
        {
          path: 'assistant',
          name: 'Assistant',
          component: () => import('../views/assistant/index.vue'),
          meta: { title: '官方助手', requiresAuth: true }
        },
        {
          path: 'greet',
          name: 'Greet',
          component: () => import('../views/greet/index.vue'),
          meta: { title: '打招呼语管理', requiresAuth: true }
        },
    ],
    meta: { requiresAuth: true }
  },
  // 添加通配符路由，捕获所有未匹配的路径
  {
    path: '/:pathMatch(.*)*',
    redirect: '/dashboard'
  }
]

// 确保 BASE_URL 正确设置
const BASE_URL = import.meta.env.BASE_URL || '/';

const router = createRouter({
  history: createWebHashHistory(BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 页面切换时滚动到顶部
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('token')
  
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login')
  } else {
    next()
  }
})

export default router
